import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { useSnackbar } from "src/utils/useSnackbar";
import { getAllActionPlanKey } from "./useGetAllActionPlan";
import { getOneActionPlanKey } from "./useGetOneActionPlan";
import { getAllActionPlanActionsKey } from "../ActionPlanAction/useGetAllActionPlanAction";
import { getOneActionPlanActionsKey } from "../ActionPlanAction/useGetOneActionPlanAction";

export const useRecalculateActionPlan = (actionPlanID: string | undefined) => {
    const snackbar = useSnackbar();
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: async (_?: unknown) => {
            if (actionPlanID === undefined) {
                snackbar.forceClose();
                snackbar.setSnackbarProps({
                    type: "error",
                    message: "Missing an ActionPlanID. Please, contact your admin.",
                });
                return;
            }

            snackbar.forceClose();
            snackbar.setSnackbarProps({
                type: "info",
                message: "Recalculating... please, wait",
                forceAutoHideInMilisecond: null,
            });

            // Invalider les caches avant recalcul
            queryClient.invalidateQueries([getAllActionPlanKey]);

            const url = `/api/action_plans/${actionPlanID}/recalculate-simulation`;
            const req = loggedInApiCall.post(
                url,
                {},
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                },
            );
            return req;
        },
        onSuccess: () => {
            snackbar.forceClose();
            snackbar.setSnackbarProps({
                type: "success",
                message: "Recalculation done !",
            });

            // Invalider toutes les queries liées aux actions pour synchroniser le cache
            queryClient.invalidateQueries([getOneActionPlanKey]);
            queryClient.invalidateQueries([getAllActionPlanKey]);
            queryClient.invalidateQueries([getOneActionPlanActionsKey]);
            queryClient.invalidateQueries([getAllActionPlanActionsKey]);
        },
        onError: () => {
            snackbar.forceClose();
            snackbar.setSnackbarProps({
                type: "error",
                message: "Recalculation failed, retry ?",
            });

            // Même en cas d'erreur, invalider les caches pour être sûr
            queryClient.invalidateQueries([getOneActionPlanKey]);
        },
    });

    return query;
};
